import React from 'react';
import { ManagerTimesheetList } from '../../../components/mobile/m-timesheet';

// Simplified approach: Just render the list directly for now
const ManagerTimesheetRoutes: React.FC = () => {
  // Just render the list component directly to verify it works
  return <ManagerTimesheetList />;
};

export default ManagerTimesheetRoutes;
